module.exports = function() {
  return new Worker(__webpack_public_path__ + "d9189aad2c3d50d271e3.worker.js");
};